import React from "react";
import { PageHero, Section } from "../components/PageShell";
import { GLOBAL_PRESENCE } from "../data/site";

const GlobalPresence = () => (
    <>
        <PageHero
            eyebrow={GLOBAL_PRESENCE.eyebrow}
            title={GLOBAL_PRESENCE.title}
        />

        <Section>
            <div className="aspect-[16/7] w-full overflow-hidden bg-[var(--ns-paper)] mb-16 border border-[var(--ns-border)]">
                <img
                    src={GLOBAL_PRESENCE.image}
                    alt="World map"
                    className="w-full h-full object-cover grayscale"
                    loading="lazy"
                />
            </div>

            <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
                <div className="lg:col-span-5">
                    <h2
                        className="font-display text-2xl lg:text-3xl font-bold tracking-tight"
                        style={{ color: "var(--ns-ink)" }}
                    >
                        Regions We Serve
                    </h2>
                    <p
                        className="font-body mt-6 text-[17px] leading-relaxed"
                        style={{ color: "var(--ns-body)" }}
                    >
                        {GLOBAL_PRESENCE.regionsLead}
                    </p>
                </div>
                <div className="lg:col-span-7">
                    <ul className="grid sm:grid-cols-2 gap-x-8">
                        {GLOBAL_PRESENCE.regions.map((r, i) => (
                            <li
                                key={r}
                                className="flex items-center justify-between py-5 border-b border-[var(--ns-border)]"
                                data-testid={`region-${i}`}
                            >
                                <span
                                    className="font-display text-lg font-medium"
                                    style={{ color: "var(--ns-ink)" }}
                                >
                                    {r}
                                </span>
                                <span
                                    className="font-body text-xs"
                                    style={{ color: "var(--ns-muted-2)" }}
                                >
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </Section>

        <section className="border-t border-[var(--ns-border)] bg-[#fafaf8]">
            <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
                    <div className="lg:col-span-5">
                        <h2
                            className="font-display text-2xl lg:text-3xl font-bold tracking-tight"
                            style={{ color: "var(--ns-ink)" }}
                        >
                            Trade Capabilities
                        </h2>
                    </div>
                    <div className="lg:col-span-7">
                        <ul className="space-y-5">
                            {GLOBAL_PRESENCE.capabilities.map((c, i) => (
                                <li
                                    key={i}
                                    className="flex items-start gap-4 pb-5 border-b border-[var(--ns-border)]"
                                    data-testid={`capability-${i}`}
                                >
                                    <span
                                        className="font-display text-xs tabular-nums mt-1"
                                        style={{ color: "var(--ns-muted)" }}
                                    >
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    <span
                                        className="font-body text-lg leading-snug"
                                        style={{ color: "var(--ns-body)" }}
                                    >
                                        {c}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <Section>
            <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
                <div className="lg:col-span-5">
                    <h2
                        className="font-display text-2xl lg:text-3xl font-bold tracking-tight"
                        style={{ color: "var(--ns-ink)" }}
                    >
                        {GLOBAL_PRESENCE.modelHeading}
                    </h2>
                </div>
                <div className="lg:col-span-7">
                    <p
                        className="font-body text-[17px] leading-relaxed max-w-2xl"
                        style={{ color: "var(--ns-body)" }}
                    >
                        {GLOBAL_PRESENCE.modelBody}
                    </p>
                </div>
            </div>
        </Section>
    </>
);

export default GlobalPresence;
